import { Entity } from '$/lib/typeormExt';

import { Verification as VerificationCommon } from '$/common/entities/verifications/Verification';
export *                                      from '$/common/entities/verifications/Verification';

@Entity()
export class Verification extends VerificationCommon {
}
